import * as React from "react";
import PropTypes from "prop-types";
import { PaymentElement } from "@stripe/react-stripe-js";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import { Box, Grid, Collapse } from "@material-ui/core";
import {
  StyledDarkBackground,
  StyledGrid,
  StyledGridItem,
  SectionTitle,
  Option,
} from "../../theme/Form";
import { PaymentMethod } from "../../domain";
import { ErrorBoundary } from "../../errors";
import * as utils from "./utils";

const paymentIcon = <PaymentOutlinedIcon />;

const PaymentSection = React.memo(function PaymentSection({
  title,
  subtitle,
  useSavedCard,
  purchaseDetails,
  setUseSavedCard,
  savedPaymentDetails,
}) {
  const handleUseDefault = () => {
    setUseSavedCard(true);
    PaymentMethod.updatePaymentMethod({
      paymentMethodId: savedPaymentDetails.defaultSource.id,
      paymentIntentId: purchaseDetails.stripe.paymentIntentId,
      clientSecret: purchaseDetails.stripe.clientSecret,
    });
  };

  return (
    <Box component="section" pb={4}>
      <SectionTitle title={title} subtitle={subtitle} />

      <StyledGrid container item direction="column">
        {savedPaymentDetails.defaultSource && (
          <StyledGridItem position="bottom" item>
            <Option
              label={`Saved Card (ending in ${savedPaymentDetails.defaultSource.card?.last4})`}
              checked={useSavedCard}
              onClick={handleUseDefault}
              endIcon={paymentIcon}
            />
          </StyledGridItem>
        )}

        <StyledGridItem position={!useSavedCard ? "bottom" : undefined} item>
          <Option
            label={utils.labelForPaymentDetails(savedPaymentDetails)}
            checked={!useSavedCard}
            onClick={() => setUseSavedCard(false)}
          />
        </StyledGridItem>

        <Collapse in={!useSavedCard}>
          <Grid item>
            <StyledDarkBackground>
              <Box p={2}>
                <ErrorBoundary section="purchaseModal" variant="inline">
                  <PaymentElement />
                </ErrorBoundary>
              </Box>
            </StyledDarkBackground>
          </Grid>
        </Collapse>
      </StyledGrid>
    </Box>
  );
});

PaymentSection.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  useSavedCard: PropTypes.bool,
  setUseSavedCard: PropTypes.func.isRequired,
  savedPaymentDetails: PropTypes.shape({
    defaultSource: PropTypes.shape({
      card: PropTypes.shape({
        last4: PropTypes.string,
      }),
      id: PropTypes.string,
    }),
  }).isRequired,
  purchaseDetails: PropTypes.shape({
    stripe: PropTypes.shape({
      clientSecret: PropTypes.string,
      paymentIntentId: PropTypes.string,
    }),
  }),
};

export default PaymentSection;
